import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export interface SEOSettings {
  title: string;
  description: string;
  keywords: string;
}

const defaultSEO: SEOSettings = {
  title: "Bucara Burger | Colombian Food Truck Boise Idaho",
  description: "Bucara Burger is Boise's favorite Colombian food truck. Authentic Colombian burgers, hot dogs, Latin fast food & tropical drinks. Serving Boise, Meridian, Nampa, Caldwell, Eagle, Kuna, Idaho.",
  keywords: "Colombian food truck Boise, burgers Boise Idaho, Colombian burgers Idaho, Latin food Boise, comida colombiana en Boise",
};

export function useSEO() {
  const [seoData, setSeoData] = useState<SEOSettings>(defaultSEO);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'settings', 'seo'), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data() as SEOSettings;
        setSeoData({ ...defaultSEO, ...data });
      }
      setLoading(false);
    });

    return () => unsub();
  }, []);

  return { seoData, loading };
}
